import { NgModule } from "@angular/core"
import { Routes, RouterModule } from "@angular/router"
import { PagesComponent } from "./pages.component"
import { NetworkCoverageComponent } from "./network-coverage/network-coverage.component"

const routes: Routes = [
	{
		path: "",
		component: PagesComponent,
		children: [
			{
				path: "",
				redirectTo: "home",
				pathMatch: "full"
			},
			{
				path: "home",
				component: NetworkCoverageComponent
				// canActivate: [AuthGuard]
			},
			{
				path: "consumer-map",
				redirectTo: "home",
				pathMatch: "full"
			}
		]
	}
	// {
	//   path: 'error',
	//   component: SsoHandlerComponent
	// }
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PagesRoutingModule {}
